module.exports = __webpack_public_path__ + "static/media/photo90.2a329205.jpg";